<template>
  <div class="lmp-block clearBoth">
    <g-switch-list3
      :chip="chip"
      v-for="(d, i) in data.horizontal"
      :key="'h' + i"
      :title="d.title"
      :columns="2"
      :current="current"
      :list="d.list" />
  </div>

</template>

<script>
  import mixin from '../mixins';
  import GSwitchList3 from '../../c_game-switch/switch-list/g_switch-4'; // 横向

  export default {
    name: "zongxiao",
    mixins: [mixin],
    components: {
      GSwitchList3,
    }
  }
</script>

<style scoped lang="stylus">
  .lmp-vertical
    margin-top 7px

  .lmp-vertical + .lmp-vertical
    margin-left 7px

  .lmp-vertical:nth-of-type(6)
    margin-left 0px
</style>



// WEBPACK FOOTER //
// src/components/pageComponents/lh/zongxiao.vue